<flex-privacy-policy-header></flex-privacy-policy-header>
<div class="privacy-layout">
	<div class="privacy-layout__intro">
		<flex-privacy-policy-intro></flex-privacy-policy-intro>
		<dsy-divider class="privacy-layout__divider" divider-orientation="horizontal" divider-color="light-grey"></dsy-divider>
		<flex-privacy-policy-more-info class="privacy-layout__info-desktop"></flex-privacy-policy-more-info>
	</div>
	<flex-privacy-policy-policies class="privacy-layout__content"></flex-privacy-policy-policies>
	<flex-privacy-policy-more-info class="privacy-layout__info-mobile"></flex-privacy-policy-more-info>
</div>